const TYPES = {
  GET_REPORTS_VISIBILITY: 'GET_REPORTS_VISIBILITY',
  UPDATE_REPORTS_VISIBILITY: 'UPDATE_REPORTS_VISIBILITY'
};

export default TYPES;
